import { FormInstance } from "antd/es/form";
import _ from "lodash";
import moment from "moment";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Footer_ScreenContext } from "../footer/footer-context";

declare let window: any;

export interface IAdminNotifManagement_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IAdminNotifManagement_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  B2BGetRolesById: any[];
  B2BGetRolesById_dummy: any[];
  UploadFile: any[];
  UploadFile_dummy: any[];
  ChangeVisibilityOf: string;
  ChangeVisibilityOf_dummy: string;
  B2BAdminAddNotification: any[];
  B2BAdminAddNotification_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  isComp175739Visible: "visible" | "hidden";
}

export class AdminNotifManagement_ScreenBase extends React.PureComponent<
  IAdminNotifManagement_ScreenProps,
  any
> {
  static contextType = Footer_ScreenContext;
  declare context: React.ContextType<typeof Footer_ScreenContext>;
  adminnotifmanagement_84050_value_kuikaDateRef: React.RefObject<any>;
  adminnotifmanagement_802497_value_kuikaDateRef: React.RefObject<any>;
  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 330241,
          PropertyName: "value",
          Value: "Bildirim Kodu",
          TagName: "Label7_value",
        },
        {
          Id: 496291,
          PropertyName: "placeholder",
          Value: "Bildirim Kodu",
          TagName: "TextInput2_placeholder",
        },
        {
          Id: 530976,
          PropertyName: "value",
          Value: "Bildirim Başlığı(Kullanıcının gördüğü)",
          TagName: "Label12_value",
        },
        {
          Id: 500820,
          PropertyName: "placeholder",
          Value: "Bildirim başlığı",
          TagName: "TextInput7_placeholder",
        },
        {
          Id: 862869,
          PropertyName: "value",
          Value: "Bildirim İçeriği(Kullanıcının gördüğü)",
          TagName: "Label13_value",
        },
        {
          Id: 787174,
          PropertyName: "placeholder",
          Value: "Bildirim İçeriği",
          TagName: "TextArea1_placeholder",
        },
        {
          Id: 179972,
          PropertyName: "value",
          Value: "Bildirim Başlangıç Tarihi",
          TagName: "Label14_value",
        },
        {
          Id: 84050,
          PropertyName: "placeholder",
          Value: "Başlangıç tarihi seçiniz...",
          TagName: "Date1_placeholder",
        },
        {
          Id: 246469,
          PropertyName: "value",
          Value: "Bildirim Bitiş Tarihi",
          TagName: "Label15_value",
        },
        {
          Id: 802497,
          PropertyName: "placeholder",
          Value: "Bitiş tarihi seçiniz...",
          TagName: "Date2_placeholder",
        },
        {
          Id: 979984,
          PropertyName: "label",
          Value: "Bildirim Oluştur ve Yayınla",
          TagName: "Button2_label",
        },
        {
          Id: 628104,
          PropertyName: "value",
          Value: "Bildirim Oluştur",
          TagName: "Label5_value",
        },
        {
          Id: 222576,
          PropertyName: "label",
          Value: "Dosya Yükle",
          TagName: "Button3_label",
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 330241,
          PropertyName: "value",
          Value: "Notification Code",
          TagName: "Label7_value",
        },
        {
          Id: 496291,
          PropertyName: "placeholder",
          Value: "Notification Code",
          TagName: "TextInput2_placeholder",
        },
        {
          Id: 530976,
          PropertyName: "value",
          Value: "Notification Header (as seen by the user)",
          TagName: "Label12_value",
        },
        {
          Id: 500820,
          PropertyName: "placeholder",
          Value: "Notification title",
          TagName: "TextInput7_placeholder",
        },
        {
          Id: 862869,
          PropertyName: "value",
          Value: "Notification Content (as seen by the user)",
          TagName: "Label13_value",
        },
        {
          Id: 787174,
          PropertyName: "placeholder",
          Value: "Notification Content",
          TagName: "TextArea1_placeholder",
        },
        {
          Id: 179972,
          PropertyName: "value",
          Value: "Notification Start Date",
          TagName: "Label14_value",
        },
        {
          Id: 84050,
          PropertyName: "placeholder",
          Value: "Please select a start date...",
          TagName: "Date1_placeholder",
        },
        {
          Id: 246469,
          PropertyName: "value",
          Value: "Notification End Date",
          TagName: "Label15_value",
        },
        {
          Id: 802497,
          PropertyName: "placeholder",
          Value: "Please select an end date...",
          TagName: "Date2_placeholder",
        },
        {
          Id: 979984,
          PropertyName: "label",
          Value: "Create and Publish a Notification",
          TagName: "Button2_label",
        },
        {
          Id: 628104,
          PropertyName: "value",
          Value: "Create Notification",
          TagName: "Label5_value",
        },
        {
          Id: 222576,
          PropertyName: "label",
          Value: "Upload File",
          TagName: "Button3_label",
        },
      ],
    },
    {
      Id: "851c1167-53c5-4db2-8fec-0229c1d7a370",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 628104, PropertyName: "value", Value: "Bildirim Oluştur" },
        { Id: 330241, PropertyName: "value", Value: "Bildirim Kodu" },
        { Id: 496291, PropertyName: "placeholder", Value: "Bildirim Kodu" },
        {
          Id: 530976,
          PropertyName: "value",
          Value: "Bildirim Başlığı(Kullanıcının gördüğü)",
        },
        { Id: 500820, PropertyName: "placeholder", Value: "Bildirim başlığı" },
        {
          Id: 862869,
          PropertyName: "value",
          Value: "Bildirim İçeriği(Kullanıcının gördüğü)",
        },
        { Id: 787174, PropertyName: "placeholder", Value: "Bildirim İçeriği" },
        {
          Id: 179972,
          PropertyName: "value",
          Value: "Bildirim Başlangıç Tarihi",
        },
        {
          Id: 84050,
          PropertyName: "placeholder",
          Value: "Başlangıç tarihi seçiniz...",
        },
        { Id: 246469, PropertyName: "value", Value: "Bildirim Bitiş Tarihi" },
        {
          Id: 802497,
          PropertyName: "placeholder",
          Value: "Bitiş tarihi seçiniz...",
        },
        { Id: 222576, PropertyName: "label", Value: "Dosya Yükle" },
        {
          Id: 979984,
          PropertyName: "label",
          Value: "Bildirim Oluştur ve Yayınla",
        },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.adminnotifmanagement_496291_value_kuikaTextInputRef =
      React.createRef();
    this.adminnotifmanagement_500820_value_kuikaTextInputRef =
      React.createRef();
    this.adminnotifmanagement_84050_value_kuikaDateRef = React.createRef();
    this.adminnotifmanagement_802497_value_kuikaDateRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      B2BGetRolesById: [],
      UploadFile: [],
      ChangeVisibilityOf: "",
      B2BAdminAddNotification: [],
      Notify: false,
      isComp175739Visible: "visible",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "adminnotifmanagement",
        "footer_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.AdminNotifManagementPageInit();
    } else if (
      !this.context?.callCallbackFunction ||
      this.context?.isMasterPageInitLoaded
    ) {
      this._prevMasterPageInitLoaded =
        this.context?.isMasterPageInitLoaded ?? false;
      await this.AdminNotifManagementPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "adminnotifmanagement",
      "footer_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["B2BAdmin"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "adminnotifmanagement",
      "footer_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.AdminNotifManagementPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.AdminNotifManagementPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      adminnotifmanagement_84050_value: moment().format("YYYY-MM-DDTHH:mm:ss"),
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  AdminNotifManagementPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AdminNotifManagement/AdminNotifManagementPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BGetRolesById = result?.data.b2BGetRolesById;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AdminNotifManagementPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AdminNotifManagementPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    ReactSystemFunctions.setValueOf(
      this,
      "adminnotifmanagement_802497_value",
      ReactSystemFunctions.value(
        this,
        "adminnotifmanagement_84050_value",
        "value"
      ),
      "disablebeforedate"
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  AdminNotifManagementComponent_222576_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.UploadFile = (
      (await ReactSystemFunctions.uploadFilesWithInfo(
        ReactSystemFunctions.convertToTypeByName("", "string")
      )) as any
    ).data;
    formVars.adminnotifmanagement_175739_value = ReactSystemFunctions.toString(
      this,
      stateVars.UploadFile !== undefined
        ? stateVars.UploadFile?.length > 0
          ? stateVars.UploadFile[0].name
          : null
        : this.state.UploadFile?.length > 0
        ? this.state.UploadFile[0].name
        : null
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.AdminNotifManagementComponent_222576_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  AdminNotifManagementComponent_222576_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.UploadFile !== undefined
            ? stateVars.UploadFile?.length > 0
              ? stateVars.UploadFile[0].data
              : null
            : this.state.UploadFile?.length > 0
            ? this.state.UploadFile[0].data
            : null
        ),
        true
      )
    ) {
      stateVars.ChangeVisibilityOf =
        await ReactSystemFunctions.changeVisibilityOf(
          this,
          ReactSystemFunctions.convertToTypeByName(
            "isComp175739Visible",
            "string"
          ),
          ReactSystemFunctions.convertToTypeByName("visible", "string")
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.AdminNotifManagementComponent_222576_onClick2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.AdminNotifManagementComponent_222576_onClick2_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  AdminNotifManagementComponent_222576_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.adminnotifmanagement_175739_value = ReactSystemFunctions.toString(
      this,
      stateVars.UploadFile !== undefined
        ? stateVars.UploadFile?.length > 0
          ? stateVars.UploadFile[0].name
          : null
        : this.state.UploadFile?.length > 0
        ? this.state.UploadFile[0].name
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AdminNotifManagementComponent_979984_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      NotifCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "adminnotifmanagement_496291_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CreatedKUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "adminnotifmanagement_84050_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      EndDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "adminnotifmanagement_802497_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      Title_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "adminnotifmanagement_500820_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Message_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "adminnotifmanagement_787174_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Doc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.UploadFile !== undefined
            ? stateVars.UploadFile?.length > 0
              ? stateVars.UploadFile[0].data
              : null
            : this.state.UploadFile?.length > 0
            ? this.state.UploadFile[0].data
            : null
        ),
        "string"
      ),
      DocName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.UploadFile !== undefined
            ? stateVars.UploadFile?.length > 0
              ? stateVars.UploadFile[0].name
              : null
            : this.state.UploadFile?.length > 0
            ? this.state.UploadFile[0].name
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AdminNotifManagement/AdminNotifManagementComponent_979984_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BAdminAddNotification = result?.data.b2BAdminAddNotification;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.AdminNotifManagementComponent_979984_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AdminNotifManagementComponent_979984_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.B2BAdminAddNotification !== undefined
          ? stateVars.B2BAdminAddNotification?.length > 0
            ? stateVars.B2BAdminAddNotification[0].resultMessage
            : null
          : this.state.B2BAdminAddNotification?.length > 0
          ? this.state.B2BAdminAddNotification[0].resultMessage
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AdminNotifManagementComponent_84050_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    ReactSystemFunctions.setValueOf(
      this,
      "adminnotifmanagement_802497_value",
      ReactSystemFunctions.value(
        this,
        "adminnotifmanagement_84050_value",
        "value"
      ),
      "disablebeforedate"
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.AdminNotifManagementPageInit();
    }
  }
}
